/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
/* eslint-disable-line react/forbid-prop-types */
import React from "react"
import Head from "next/head"
import Layout from "components/Layout"
import TextPage from "components/Mobile/TextPage"
import Card from "@material-ui/core/Card"
import CardActionArea from "@material-ui/core/CardActionArea"
import CardActions from "@material-ui/core/CardActions"
import CardContent from "@material-ui/core/CardContent"
import CardMedia from "@material-ui/core/CardMedia"
import Button from "@material-ui/core/Button"
import Link from "next/link"
import { Box, Typography } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { imageSrcHelper } from "settings"

const useStyles = makeStyles((theme) => ({
  root: {
    // maxWidth: 345,
    marginBottom: theme.spacing(2),
  },
  media: {
    height: 240,
  },
}))

const BlogPage = (props) => {
  const classes = useStyles()
  return (
    <Layout>
      <Head>
        <title>Blog</title>
      </Head>
      <TextPage
        pageTitle="Blog"
        pageContent={
          <>
            {props.blogPosts?.map((post) => (
              <Link href={`/blog-article/${post.slug}`} key={Math.random()}>
                <Card className={classes.root}>
                  <CardActionArea>
                    <CardMedia
                      className={classes.media}
                      image={imageSrcHelper(post.thumbnail, "medium")}
                      title={post.title}
                    />
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="h2">
                        {post.title}
                      </Typography>
                      <Typography variant="body2" color="textSecondary" component="p">
                        {post.content?.substr(0, post.content.lastIndexOf(" ", 140))} ...
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                  {/* <CardActions>
                  <Button size="small" color="primary">
                    Share
                  </Button>
                  <Button size="small" color="primary">
                    Learn More
                  </Button>
                </CardActions> */}
                </Card>
              </Link>
            ))}

            <Box my={2}>
              <Card className={classes.root}>
                <CardContent>
                  <Typography className={classes.title} color="textSecondary" gutterBottom>
                    È il tuo momento
                  </Typography>
                  <Typography variant="h5" component="h2">
                    Ispira altri BadTravellers come te e condividi la tua esperienza di viaggio!
                  </Typography>

                  <Typography variant="body2" component="p">
                    Scrivici via mail a info@badtraveller.com inviandoci anche delle foto, la tua esperienza potrà
                    essere pubblicata nel nostro blog.
                  </Typography>
                </CardContent>
                <CardActions>
                  <Button size="small" href="mailto:info@badtraveller.com">
                    SCRIVICI
                  </Button>
                </CardActions>
              </Card>
            </Box>
          </>
        }
      />
    </Layout>
  )
}

export default BlogPage

export async function getStaticProps() {
  let res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/blog-posts?_sort=createdAt:desc`)
  const blogPosts = await res.json()

  return {
    props: {
      blogPosts,
    },
    revalidate: 1,
  }
}
